import { Typography as T, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";

import { useCurrency, useTypedTheme } from "hooks";
import { AddonCart } from "store/types";
import { palette } from "theme/palette";

type Props = {
  addonsToDisplay: AddonCart[];
  label?: string;
};

export const AddonSummaryItem = ({ label, addonsToDisplay }: Props) => {
  // styles
  const {
    theme: {
      breakpoints: { down },
    },
  } = useTypedTheme();
  const isMobile = useMediaQuery(down("sm"));

  const { formatPrice } = useCurrency();

  if (!addonsToDisplay.length) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      {!!label && (
        <T
          variant="cardFooter"
          sx={{
            marginBottom: "8px",
          }}
        >
          {label}
        </T>
      )}
      {addonsToDisplay.map((addon, i: number) => {
        if (!addon?.count) return null;

        return (
          <Box
            key={i}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "8px",
              border: `1px solid ${palette.grey}`,
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "14px 15px 15px 16px",
              }}
            >
              <T variant="cardLabelText" sx={{ maxWidth: "100%", flexGrow: 2 }}>
                {addon.name} ({addon.count})
              </T>
            </Box>

            <Box
              sx={{
                padding: isMobile ? "14px" : "11px 14px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: palette.grey,
              }}
            >
              <T variant="h3">
                {formatPrice(
                  Number(addon.price ?? 0) * Number(addon.count ?? 0)
                )}
              </T>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
